import type { ApiConfig } from '../../types'

export const convertHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1000,
  order: 'asc',
  range: 30 * 24 * 60 * 60 * 1000, // 30 days
  requiresRange: true,
  type: 'convert-history',
} as const satisfies ApiConfig
